/**
 * @module websocket.event.handlers.pilots.pilot-list-updated
 */
import { store } from '../../../../state/store'
import { setPilotListUpdated } from '../../../../state/websocket.slice'

export default function handlePilotListUpdated(context) {
  const { payload: { channelId, data } = {} } = context
  if (!data || !channelId) {
    return
  }

  const isSubscribed = store
    .getState()
    ?.websocket?.subscriptions?.some((channel) => channel === channelId)

  if (isSubscribed) {
    store.dispatch(setPilotListUpdated(data))
  }
} 